module.exports = __webpack_public_path__ + "static/IBMPlexSans-Bold-Latin1-f450470a2e6add0f30a5ea422b833789.woff2";